declare namespace $ {

	type $mol_check__checked_bog_blitz_1 = $mol_type_enforce<
		ReturnType< $bog_blitz['mobile_menu_showed'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_check__sub_bog_blitz_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_check['sub'] >
	>
	type $bog_theme_toggle__theme_auto_bog_blitz_3 = $mol_type_enforce<
		ReturnType< $bog_blitz['Theme'] >
		,
		ReturnType< $bog_theme_toggle['theme_auto'] >
	>
	type $mol_link_source__uri_bog_blitz_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_link_source['uri'] >
	>
	type $mol_row__sub_bog_blitz_5 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_row['sub'] >
	>
	type $mol_text__text_bog_blitz_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_pick__hint_bog_blitz_7 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__trigger_content_bog_blitz_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_bog_blitz_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $bog_theme_auto__theme_light_bog_blitz_10 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_theme_auto['theme_light'] >
	>
	type $bog_theme_auto__theme_dark_bog_blitz_11 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_theme_auto['theme_dark'] >
	>
	type $bog_theme_auto__themes_bog_blitz_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_theme_auto['themes'] >
	>
	type $mol_switch__value_bog_blitz_13 = $mol_type_enforce<
		ReturnType< $bog_blitz['screen'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_bog_blitz_14 = $mol_type_enforce<
		ReturnType< $bog_blitz['nav_options'] >
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_switch__value_bog_blitz_15 = $mol_type_enforce<
		ReturnType< $bog_blitz['screen'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_bog_blitz_16 = $mol_type_enforce<
		ReturnType< $bog_blitz['nav_options'] >
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_pop__showed_bog_blitz_17 = $mol_type_enforce<
		ReturnType< $bog_blitz['mobile_menu_showed'] >
		,
		ReturnType< $mol_pop['showed'] >
	>
	type $mol_pop__Anchor_bog_blitz_18 = $mol_type_enforce<
		ReturnType< $bog_blitz['Mobile_menu_trigger'] >
		,
		ReturnType< $mol_pop['Anchor'] >
	>
	type $mol_pop__bubble_content_bog_blitz_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pop['bubble_content'] >
	>
	export class $bog_blitz extends $mol_page {
		Lobby( ): $bog_blitz_lobby
		Admin( ): $bog_blitz_admin
		Profile( ): $bog_blitz_profile_page
		screen( next?: string ): string
		mobile_menu_showed( next?: boolean ): boolean
		Mobile_menu_icon( ): $mol_icon_menu
		Mobile_menu_trigger( ): $mol_check
		Settings_icon( ): $mol_icon_cog
		Status( ): $giper_baza_status
		Theme_toggle( ): $bog_theme_toggle
		Sources( ): $mol_link_source
		Settings_content( ): $mol_row
		Powered( ): $mol_text
		Settings( ): $mol_pick
		Radio( ): $bog_blitz_radio
		Theme( ): $bog_theme_auto
		screen_body( ): readonly(any)[]
		title( ): string
		pages( ): ({ 
			'lobby': ReturnType< $bog_blitz['Lobby'] >,
			'admin': ReturnType< $bog_blitz['Admin'] >,
			'profile': ReturnType< $bog_blitz['Profile'] >,
		}) 
		nav_options( ): ({ 
			'lobby': string,
			'admin': string,
			'profile': string,
		}) 
		Navbar( ): $mol_switch
		Mobile_nav( ): $mol_switch
		Mobile_menu( ): $mol_pop
		tools( ): readonly(any)[]
		head( ): readonly(any)[]
		plugins( ): readonly(any)[]
		body( ): ReturnType< $bog_blitz['screen_body'] >
	}
	
}

//# sourceMappingURL=blitz.view.tree.d.ts.map